export { ReactComponent as QuestionsFill } from './svgs/questions-fill.svg';
